import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
const groupMembersData = createSlice({
    name:'groupMembersData',
    initialState,
    reducers:{
        addGroupMembersData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default groupMembersData.reducer
export const addGroupMembersData = groupMembersData.actions.addGroupMembersData